import {RestApiService} from '../../../../rest-api.service';
import {ApiV0AdminIntEmailClient} from './api.v0.admin.integrations.emailClients';
import {ApiV0Administration} from '../../api.v0.administration';
import {ApiV0AdminIntegrationsEmailClientsV3} from './api.v0.admin.integrations.emailClients.v3';

export class ApiV0AdminIntegrations {
    segment = '/integrations';

    constructor(
        v0: ApiV0Administration,
        api: RestApiService,
    ) {
        this.segment = v0.segment + this.segment;
        this.emailClients = new ApiV0AdminIntEmailClient(this, api);
        this.emailClientsV3 = new ApiV0AdminIntegrationsEmailClientsV3(this, api)
    }


    public readonly emailClients: ApiV0AdminIntEmailClient;
    public readonly emailClientsV3: ApiV0AdminIntegrationsEmailClientsV3;




}